module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uix-tree-selected"
  }, [(_vm.selected.id) ? _c('ui-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "flat",
      "color": "primary",
      "icon": "highlight_off"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearSelected($event)
      }
    }
  }, [_vm._v("Usuń wybór")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [(_vm.selected.id) ? _c('strong', [_vm._v(_vm._s(_vm.selected.name))]) : _vm._e(), _vm._v(" "), (!_vm.selected.id) ? _c('strong', [_vm._v("—")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62f5bed2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui/TreeSelected.vue
// module id = 266
// module chunks = 0